import { dateFormatter } from './date';
export function getLocalizerProvider(translations, globals) {
    const map = getMap(translations, globals);
    return (language) => {
        const fn = (key, ...params) => {
            const value = getValue(map, language, key, params);
            return value;
        };
        return new Localizer(fn, dateFormatter(language));
    };
}
function getValue(translations, language, key, params) {
    const map = translations[language];
    if (!map) {
        return null;
    }
    const value = map.get(key);
    if (value === undefined) {
        map.set(key, null);
        return null;
    }
    if (typeof value === 'function') {
        return value(...params);
    }
    return value;
}
function getMap(translations, globals) {
    const result = {};
    for (const locale in translations) {
        if (translations.hasOwnProperty(locale)) {
            const data = translations[locale];
            result[locale] = getHashMap({ ...data, ...globals });
        }
    }
    return result;
}
function getHashMap(data) {
    const result = new Map();
    function serialize(o, namespace = '', isArray = false) {
        for (const key in o) {
            if (o.hasOwnProperty(key)) {
                const value = o[key];
                const keyPath = isArray ? `[${key}]` : key;
                const path = namespace + keyPath;
                if (isObject(value)) {
                    serialize(value, path + '.');
                }
                else if (Array.isArray(value)) {
                    serialize(value, path, true);
                }
                else {
                    if (typeof value === 'function') {
                        result.set(path, value.bind(o));
                    }
                    else {
                        result.set(path, value);
                    }
                }
            }
        }
    }
    serialize(data);
    return result;
}
function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
export class Localizer {
    constructor(get, format) {
        this.get = get;
        this.format = format;
    }
}
